



















































import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { NoveltyRule } from '@/models/api/campaign/noveltyCampaign'
import { SkuConstraint } from '@/usecases/novelty/sku-constraint'
import { SkuSummary } from '@/usecases/novelty/sku-summary'
import CountControl from '@spa/components/atoms/CountControl.vue'
import { SelectItem } from '@spa/components/atoms/model/SelectItem'
import { PluginMixin } from '@spa/mixins/plugin'
import { Selection } from './selection'

import { Novelty } from '@/models/novelty/novelty'

@Component({
  components: {
    CountControl,
  },
})
export default class NoveltyItem extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  summary: SkuSummary

  get rule(): NoveltyRule {
    return this.summary.rule
  }

  get novelty(): Novelty {
    return this.summary.novelty
  }

  get constraint(): SkuConstraint {
    return new SkuConstraint(this.summary)
  }

  get fkuId(): string {
    return this.novelty.fkuId
  }

  get productName(): string {
    return this.novelty.productName
  }

  get description(): string {
    // Presuppose FKU color is correctly set.
    return `${this.novelty.color} ${this.novelty.size}`
  }

  get thumbnail(): string {
    return this.novelty.thumbnail
  }

  get count(): number {
    return this.summary.selection.count
  }

  get maxCount(): number {
    return this.summary.priceBasedMaxCount
  }

  get countList(): SelectItem[] {
    return _.range(this.rule.select_limit + 1).map((count) => {
      return {
        text: `${count}`,
        value: `${count}`,
      }
    })
  }

  get shouldReselect(): boolean {
    return this.count > 0 && !this.constraint.isCountValid
  }

  get shouldShow(): boolean {
    return this.summary.userCanChangeCount
  }

  handleSelect(changedCount: number): void {
    this.emitSelect({
      skuId: this.novelty.skuId,
      count: changedCount,
    })
  }

  @Emit('select')
  emitSelect(_selection: Selection) {
    // Do nothing
  }
}
